import React from 'react';
import moment from 'moment';
import {makeStyles, Typography} from '@material-ui/core';
import {CSVLink} from "react-csv";
import {useIntl} from 'react-intl';
import LeaveRecordCollection from '../../Function/LeaveRecordCollection'
import customAxios from "../../API/customAxios";

const useStyles = makeStyles((theme) => ({
    csvLink: {
        color: 'white',
        '&:hover': {
            color: 'white',
        },
        display: 'contents'
    },
    button: {
        height: '2.8em',
        backgroundColor: '#2C3E50',
        '&:hover': {
            backgroundColor: '#080C0F',
        }
    },
}));

export default function ExportLeaveDetail({setIsActive}) {
    const classes = useStyles();
    const intl = useIntl();
    const [csvLeaveRecord, setCsvLeaveRecord] = React.useState([]);
    const [filename, setFilename] = React.useState('');
    const csvLink = React.useRef();

    const headers = [
        {label: intl.formatMessage({id: 'leave_approval.staff_number'}), key: "staffNo"},
        {label: intl.formatMessage({id: 'leave_approval.employee'}), key: "employeeName"},
        {label: intl.formatMessage({id: 'leave_approval.position'}), key: "position"},
        {label: intl.formatMessage({id: 'leave_approval.location'}), key: "location"},
        {label: intl.formatMessage({id: 'leave_approval.department'}), key: "department"},
        {label: intl.formatMessage({id: 'new_application.leave_type'}), key: "type"},
        {label: intl.formatMessage({id: 'table.date_submitted'}), key: "dateSubmitted"},
        {label: intl.formatMessage({id: 'common.from'}), key: "startDate"},
        {label: intl.formatMessage({id: 'common.to'}), key: "untilDate"},
        {label: intl.formatMessage({id: 'new_application.taken'}), key: "period"},
        {label: intl.formatMessage({id: 'new_application.supporting_document'}), key: "attachment"},
        {label: intl.formatMessage({id: 'table.reason_of_leave'}), key: "reason"},
        {label: intl.formatMessage({id: 'table.status'}), key: "status"},
        {label: intl.formatMessage({id: 'table.reject_reason'}), key: "rejectReason"},
    ];

    function getData() {
        setIsActive(true);
        customAxios.get(`/get_team_leaves?is_export=true`)
            .then(res => {
                const csvData = jsonBeautifier(res.data['application']);
                const currentDate = moment().format('YYYY_MM_DD');
                setFilename('Employees_Leave_Detail_Report_' + currentDate + '.csv');
                setCsvLeaveRecord(LeaveRecordCollection(csvData, 'ExportLeaveDetail', intl));
                setIsActive(false);
                csvLink.current.link.click();
            })
    }

    function jsonBeautifier(getData) {
        const data = [];
        for (let i = 0; i < getData.length; i++) {
            for (let j = 0; j < getData[i].length; j++) {
                data.push(getData[i][j])
            }
        }
        return data;
    }

    return (
        <div>
            <Typography onClick={getData}
                        style={{color: '#000'}}>{intl.formatMessage({id: 'myteam.leave_detail'})}</Typography>
            <CSVLink filename={filename} data={csvLeaveRecord} headers={headers} className={classes.csvLink}
                     ref={csvLink}/>
        </div>
    );
}
